import { createClient, Session } from '@supabase/supabase-js';

type AuthConfigResponse = { supabase_url: string; publishable_key: string };
type AuthConfig = { url: string; publishableKey: string };
let session: Session | null = null;
let config: AuthConfig | null = null;

export async function initAuth() {
  const response = await fetch('/api/auth/config');
  if (!response.ok) throw new Error('Supabase Auth não está configurado.');
  const loaded = await response.json() as AuthConfigResponse;
  config = { url: loaded.supabase_url, publishableKey: loaded.publishable_key };
  const client = createClient(config.url, config.publishableKey);
  session = (await client.auth.getSession()).data.session;
  client.auth.onAuthStateChange((_event, next) => { session = next; });
  return client;
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  if (session?.access_token) headers.set('Authorization', `Bearer ${session.access_token}`);
  if (init?.body) headers.set('Content-Type', 'application/json');
  const response = await fetch(path, { ...init, headers });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || `Erro HTTP ${response.status}`);
  return data as T;
}

export const money = (value: number, currency = 'BRL') => new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format(value || 0);
export const number = (value: number) => new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(value || 0);
export const percent = (value: number) => `${number(value)}%`;
